module.exports = __webpack_public_path__ + "static/media/ss-1.3a28b59c.png";